module.exports = __webpack_public_path__ + "static/mo44-17f6b1b50adad73ffd918a9900326ae5.png";